import { authSliceActions } from 'app/pages/auth/redux/auth-slice';
import type { AppDispatch } from 'app/redux/types/types';

export const setAuthenticationKeysActionCreator =
    (codeVerifier: string, authenticationKey: string) => (dispatch: AppDispatch) => {
        dispatch(
            authSliceActions.setAuthenticationKeys({
                codeVerifier,
                authenticationKey,
            }),
        );
    };
